import { Link } from 'react-router-dom';

export default function BlogPostCard({ post }) {
  return (
    <Link to={`/blog/${post.slug}`} className="group block relative h-72 rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
      {post.cover_image && (
        <img src={post.cover_image} alt={post.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
        {post.category && (
          <span className="text-xs font-semibold uppercase tracking-wider text-blue-300">{post.category}</span>
        )}
        <h3 className="text-lg font-semibold mt-1 mb-2 line-clamp-2">{post.title}</h3>
        {post.published_at && (
          <div className="text-xs text-gray-300">
            {post.author_name && <>{post.author_name} · </>}
            {new Date(post.published_at).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
          </div>
        )}
      </div>
    </Link>
  );
}
